<div class="container relative md:mt-24 mt-16">
  <!-- Section Title -->
  <div class="grid grid-cols-1 pb-6 text-center">
    <h3 class="mb-4 text-2xl md:text-3xl font-bold leading-snug text-slate-900 dark:text-white">
      HarmoNest Blog
    </h3>
    <p class="text-slate-500 dark:text-slate-400 max-w-2xl mx-auto text-sm md:text-base">
      Discover travel tips, hosting advice, and local insights from cities across Germany – curated by the HarmoNest team.
    </p>
  </div>

  <!-- Blog Cards -->
  <div class="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 mt-10 gap-8">
    <div *ngFor="let item of blogData | slice : 0 : 3" class="group bg-white dark:bg-slate-900 rounded-2xl shadow-[0_20px_50px_rgba(0,0,0,0.1)] dark:shadow-[0_20px_50px_rgba(0,0,0,0.5)] overflow-hidden transition-transform ">
      <!-- Image with hover effects -->
      <div class="relative overflow-hidden h-56">
        <img
          [src]="item.image"
          alt=""
          class="w-full h-full object-cover transform group-hover:scale-110 group-hover:rotate-1 transition duration-500"
        />
        <!-- Tag -->
        <div class="absolute top-0 left-0 p-4 opacity-0 group-hover:opacity-100 transition duration-500">
          <span class="bg-red-500 text-white text-xs px-3 py-1 font-semibold rounded-md">
            {{ item.tag }}
          </span>
        </div>
      </div>

      <!-- Content -->
      <div class="p-5">
        <!-- Meta Info -->
        <div class="flex items-center text-sm text-slate-400 mb-3 space-x-4">
          <span class="flex items-center">
            <i data-feather="clock" class="w-4 h-4 text-slate-900 dark:text-white mr-1.5"></i>5 min read
          </span>
          <span>
            by
            <a href="#" class="text-slate-900 dark:text-white hover:text-red-500 font-medium transition">
              HarmoNest Team
            </a>
          </span>
        </div>

        <!-- Title -->
        <a
          [routerLink]="['/blog-detail', item.id]"
          class="block text-lg font-semibold text-slate-900 dark:text-white hover:text-red-500 transition"
        >
          {{ item.title }}
        </a>

        <!-- Description -->
        <p class="text-slate-500 dark:text-slate-400 mt-2 text-sm">
          {{ item.desc }}
        </p>

        <!-- Read More -->
        <div class="mt-4">
          <a
            [routerLink]="['/blog-detail', item.id]"
            class="inline-flex items-center text-sm font-medium text-red-500 hover:underline"
          >
            Read More <i data-feather="chevron-right" class="w-4 h-4 ml-1"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
